export class RatingReg {
    constructor(ratingRegId: string, ratingValue: number, ratingComment: string | null) {
        this.ratingRegId = ratingRegId;
        this.ratingValue = ratingValue;
        this.ratingComment = ratingComment;
    }
    ratingRegId: string;
    ratingValue: number;
    ratingComment: string | null;
}
